export default __webpack_public_path__ + "static/media/right_arrow_icon.c61f59a9.svg";